import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const socialProofData = [{
  name: 'Lucía M.',
  city: 'Córdoba'
}, {
  name: 'Martín R.',
  city: 'Rosario'
}, {
  name: 'Valentina S.',
  city: 'Mendoza'
}, {
  name: 'Santiago P.',
  city: 'Tucumán'
}, {
  name: 'Camila G.',
  city: 'La Plata'
}, {
  name: 'Federico L.',
  city: 'Mar del Plata'
}, {
  name: 'Sofía D.',
  city: 'Salta'
}, {
  name: 'Nicolás B.',
  city: 'Santa Fe'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const showPopup = () => {
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
        setCurrentIndex(prev => (prev + 1) % socialProofData.length);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 3000);
    // Recurring interval
    const interval = setInterval(showPopup, 7000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [dismissed]);
  const currentPerson = socialProofData[currentIndex];
  if (dismissed) return null;
  return <AnimatePresence data-id="element-221">
      {isVisible && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 200
    }} className="fixed bottom-4 left-4 z-50 bg-[#FDF8F3] rounded-lg shadow-2xl border border-[#E0D5C8] p-4 max-w-xs" data-id="element-222">
          <button onClick={() => setDismissed(true)} className="absolute top-2 right-2 text-[#8B7355] hover:text-[#5C4033]" aria-label="Cerrar" data-id="element-223">
            <XIcon className="w-4 h-4" data-id="element-224" />
          </button>
          <div className="flex items-start gap-3" data-id="element-225">
            <div className="flex-shrink-0" data-id="element-226">
              <CheckCircleIcon className="w-10 h-10 text-[#8B9E7E]" data-id="element-227" />
            </div>
            <div data-id="element-228">
              <p className="text-sm text-[#8B7355]" data-id="element-229">
                <span className="font-semibold text-[#5C4033]" data-id="element-230">
                  {currentPerson.name}
                </span>{' '}
                de{' '}
                <span className="font-semibold text-[#5C4033]" data-id="element-231">
                  {currentPerson.city}
                </span>
              </p>
              <p className="text-sm font-medium text-[#8B9E7E] mt-1" data-id="element-232">
                acaba de adquirir Crianza Montessori en Casa
              </p>
              <p className="text-xs text-[#8B7355]/60 mt-1" data-id="element-233">
                Hace unos momentos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}